import axios from 'axios';
/**
 * 微信相关
 */
export default {
	/**
   * 获取签名
   * @returns {Promise<void>}
   */
	async signature() {
		let { data } = await axios.get(`/weixin/signature`);
		return data;
	},
	/**
   * 微信校验code
   * @returns {Promise<void>}
   */
	async sendCode({ code, type }) {
		let { data } = await axios.get(`/weixin/weChatPhoneLogin?code=${code}&type=${type}`);
		return data;
	}
};
